/**
 * @Description 可以左右点击切换的tabs
 * 从src/views/youth/pages/map/components/LeftContent/DistrictDimension/CityInfo/CompetitorData/index.tsx文件中抽离出来的
 */

import { FC, useEffect, useRef, useState } from 'react';
import { useMethods } from '@lhb/hook';
import { isArray } from '@lhb/func';
import cs from 'classnames';
import styles from './index.module.less';
import IconFont from '@/common/components/IconFont';

interface MoreTabsProps {
  tabs: any[];
  scrollStep?: number;
  tabName?: string;
  tabId?: string;
  onChange?: (target: any) => void;
  handleBigdataFn?: () => void;
  className?: any;
}
const MoreTabs: FC<MoreTabsProps> = ({
  tabs,
  scrollStep = 100,
  tabName = 'name',
  tabId = 'id',
  className,
  onChange,
  handleBigdataFn,
}) => {
  const tabsRef = useRef<HTMLDivElement>(null);
  const [activeKey, setActiveKey] = useState('');
  const [showLeftBtn, setShowLeftBtn] = useState(false);
  const [showRightBtn, setShowRightBtn] = useState(true);

  // 初始检查和添加滚动监听
  useEffect(() => {
    return () => {
      tabsRef.current?.removeEventListener?.('scroll', methods.checkScrollPosition);
    };
  }, []);

  useEffect(() => {
    if (isArray(tabs) && tabs.length) {
      methods.checkScrollPosition();
      if (tabsRef.current) {
        tabsRef.current.addEventListener('scroll', methods.checkScrollPosition);
      }
      setActiveKey(tabs[0]?.[tabId]?.toString());
      onChange && onChange(tabs[0]);
    }
  }, [tabs]);

  const methods = useMethods({
    checkScrollPosition() {
      if (!tabsRef.current) return;

      const { scrollLeft, scrollWidth, clientWidth } = tabsRef.current || {};

      setShowLeftBtn(scrollLeft > 10); // 留一点缓冲避免边界闪烁
      setShowRightBtn(scrollLeft < scrollWidth - clientWidth - 10);
    },
    handleScrollLeft() {
      if (tabsRef.current) {
        tabsRef.current.scrollBy({ left: -scrollStep, behavior: 'smooth' });
      }
    },
    handleRank(item: any) {
      setActiveKey(item?.[tabId]?.toString());
      onChange && onChange(item);
      handleBigdataFn && handleBigdataFn();
    },
    handleScrollRight() {
      if (tabsRef.current) {
        tabsRef.current.scrollBy({ left: scrollStep, behavior: 'smooth' });
      }
    },
  });

  return (<>
    {
      tabs.length > 0 && <div className={cs(styles.tabsCon, className)}>
        {showLeftBtn && (
          <div
            className={cs(styles.leftBtn, styles.positionBtn)}
            onClick={methods.handleScrollLeft}
          >
            <IconFont iconHref='icon-arrow-left' className={styles.icon} />
          </div>
        )}
        <div ref={tabsRef} className={styles.rankCon}>
          {
            tabs.map((item, index) => {
              return <div
                key={index}
                className={cs(styles.rankItem, activeKey === item?.[tabId]?.toString() ? styles.active : '')}
                onClick={() => methods.handleRank(item)}
              >
                {item[tabName]}
              </div>;
            })
          }
        </div>
        {showRightBtn && (
          <div
            className={cs(styles.rightBtn, styles.positionBtn)}
            onClick={methods.handleScrollRight}
          >
            <IconFont iconHref='icon-arrow-left' className={styles.icon} />
          </div>
        )}
      </div>
    }
  </>

  );
};

export default MoreTabs;
